export interface AiFeature {
  id: string;
  icon: string;
  label: string;
  description: string;
}

export interface AiFeatureGroup {
  id: string;
  title: string;
  features: readonly AiFeature[];
}

export const aiFeatureGroups: readonly AiFeatureGroup[] = [
  {
    id: 'appointment',
    title: 'Per ogni colloquio',
    features: [
      {
        id: 'transcription',
        icon: 'record_voice_over',
        label: 'Trascrizione',
        description: "Converte automaticamente l'audio dei colloqui in testo.",
      },
      {
        id: 'appsumm',
        icon: 'summarize',
        label: 'Sintesi Colloquio',
        description:
          'Genera una sintesi concisa dei punti chiave discussi durante il colloquio.',
      },
      {
        id: 'appwordcloud',
        icon: 'cloud',
        label: 'Wordcloud',
        description:
          'Crea una rappresentazione visiva delle parole più frequenti nel colloquio.',
      },
      {
        id: 'catdistr',
        icon: 'assessment',
        label: 'Distribuzione Topic Nucleari',
        description:
          'Mostra quanto spazio ha avuto nel colloquio ciascun topic nucleare, i temi predefiniti comuni a ogni psicoterapia.',
      },
      {
        id: 'apptopics',
        icon: 'topic',
        label: 'Topic AI',
        description:
          "L'AI individua autonomamente i temi trattati nel colloquio, senza partire da un elenco predefinito. Per ciascuno raccoglie le espressioni che mostrano come è stato affrontato.",
      },
    ],
  },
  {
    id: 'history',
    title: "Per l'intero percorso",
    features: [
      {
        id: 'patdmr',
        icon: 'schema',
        label: 'Scheda Clinica Dinamica',
        description:
          'Fornisce una sintesi strutturata e schematica dei principali argomenti trattati con il paziente.',
      },
      {
        id: 'patsumm',
        icon: 'subject',
        label: 'Sintesi Complessiva',
        description:
          'Offre una panoramica discorsiva di tutti gli aspetti rilevanti trattati con il paziente.',
      },
      {
        // Not a service on its own: catdistr trend across all the appointments.
        id: 'catdistr-trend',
        icon: 'trending_up',
        label: 'Topic Nucleari nel Tempo',
        description:
          'Mostra come cambia nel tempo il peso di ciascun topic nucleare lungo tutti i colloqui del paziente.',
      },
    ],
  },
];

export const aiFeatures: readonly AiFeature[] = aiFeatureGroups.flatMap(
  (group) => group.features
);

export const aiAnalysisDescription: string = `
            <p>Seleziona un <strong>Paziente</strong> e guarda tutti i colloqui passati.</p>
            <p><strong>Carica la registrazione</strong> di un colloquio cliccando sull'apposito tasto e <strong>avvia la pipeline AI</strong>.</p>
            <p>Una volta completata accedi alla <strong>pagina del colloquio</strong> cliccando sul titolo.</p>
            <p><strong>Genera il riassunto sul Paziente</strong> cliccando l'apposito tasto sopra la tabella.</p>
        `;
